import React, {useEffect, useState, useRef} from 'react';
import Footer from '../../../shared/Footer';
import "./projects-detail-page.css";
import { Fade } from 'react-reveal';
import { Waypoint } from 'react-waypoint';
import Cunovo1 from '../../../images/projects/cunovo.jpg';
import Cunovo2 from '../../../images/projects/cunovo2.jpg';
import Cunovo3 from '../../../images/projects/cunovo3.jpg';
import Cunovo4 from '../../../images/projects/cunovo4.jpg';
import Cunovo5 from '../../../images/projects/cunovo5.jpg';
import Cunovo6 from '../../../images/projects/cunovo6.jpg';
import Cunovo7 from '../../../images/projects/cunovo7.jpg';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {responsive} from './Carousel.js';

export default function PolusTowers() {
    document.title = "Súbor rodinných domov Bratislava - Čunovo - kyska.sk";

    const [animationTriggered, setAnimationTriggered] = useState(false);

    const handleWaypointEnter = () => {
      setAnimationTriggered(true);
    };

    const carouselRef = useRef(null);

    const handlePrevClick = (event) => {
        event.preventDefault();
        carouselRef.current.previous();
    };

    const handleNextClick = (event) => {
        event.preventDefault();
        carouselRef.current.next();
    };

    return (
        <div>
            <Waypoint onEnter={handleWaypointEnter}>
            <Fade duration={1000}>
                <h3 className="top-heading"></h3>

                <div className='carousel-container'>
                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        draggable={false}
                        ref={carouselRef}
                        autoPlay={10000}
                        arrows={false}
                        >
       
                            <img
                            className="img-fluid" 
                            src={Cunovo1}
                            alt="First slide"
                            />
         
                            <img
                            className="img-fluid" 
                            src={Cunovo2}
                            alt="First slide"
                            />
       
                            <img
                            className="img-fluid" 
                            src={Cunovo3}
                            alt="First slide"
                            />
       
                            <img
                            className="img-fluid" 
                            src={Cunovo4}
                            alt="First slide"
                            />
           

      
                            <img
                            className="img-fluid" 
                            src={Cunovo5}
                            alt="First slide"
                            />
  
                            <img
                            className="img-fluid" 
                            src={Cunovo6}
                            alt="First slide"
                            />

                            <img
                            className="img-fluid" 
                            src={Cunovo7}
                            alt="First slide"
                            />
                </Carousel>
                </div>

                <div className="carousel-controls">
                    <a
                        className="carousel-control-prev-a"
                        href="#carousel"
                        role="button"
                        onClick={handlePrevClick}
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" class="bi bi-chevron-compact-left" viewBox="0 0 16 16" preserveAspectRatio="none">
                                <path fill-rule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"/>
                            </svg>
                        </span>
                    </a>

                    <a
                        className="carousel-control-next-a"
                        href="#carousel"
                        role="button"
                        onClick={handleNextClick}
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" class="bi bi-chevron-compact-right" viewBox="0 0 16 16" preserveAspectRatio="none">
                                <path fill-rule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"/>
                            </svg>
                        </span>
                    </a>
                </div>

                <h3 className='detail-heading'>Súbor rodinných domov Bratislava - Čunovo</h3>
                <hr className='detail-hr'/>
                <p>Projekt rieši výstavbu rodinných domov s dvoma bytovými jednotkami,  ako aj samostane stojacich rodinných domov v okrajovej MČ Bratislavy. Cieľom bolo spolu s investorom, vytvoriť moderné, úsporné condominium, kde si klienti nájdu požadovaný štandard dostupného bývania v rodinnom dome.</p>
                <br></br>

                <hr className="project-detail-hr"></hr>
                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Rok realizácie</div>
                    <div>2023</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Výkon</div>
                    <div>Projekčné práce v spolupráci s ateliérom PROREAL-INVEST s.r.o.</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Stavebník</div>
                    <div>Právnická osoba</div>
                </div>
                <hr className="project-detail-hr"></hr>

                <div className="project-detail-table" style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>Lokalita</div>
                    <div>Bratislava - Čunovo</div>
                </div>
                <hr className="project-detail-hr"></hr>
                                
            </Fade>
            </Waypoint>

            <Footer />
        </div>
    );
}
